@if (openAlert) {
  <mb-alert type="notification" [dismissible]="true" (dismiss)="togglesCloseAlert()" class='few-offer-alert'>
    <mb-alert-description>
      @if (occupancy < 85) {
        <span i18n="@@few-offer__date-high-request">El destino está siendo muy solicitado para las fechas que estás buscando</span>&nbsp;
        <strong i18n="@@few-offer__book-accommodation-asap">¡Reservá tu alojamiento cuanto antes!</strong>
      }
      @if (occupancy >= 85) {
        <span i18n="@@few-offer__date-low-availability">Ya hay poca disponibilidad en el destino para las fechas que estás buscando</span>&nbsp;
        <strong i18n="@@few-offer__book-before-out">¡Reservá antes que se agote!</strong>
      }
    </mb-alert-description>
  </mb-alert>
}
